const CreditCardIcon = ({ val }) => {
    return (
        <>
            <svg width="18" height="21" viewBox="0 0 20 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill={val ? "#fff" : ""} d="M1 5.5H19M5 9.5H8M1 1.5H19V13.5C19 14.0304 18.7893 14.5391 18.4142 14.9142C18.0391 15.2893 17.5304 15.5 17 15.5H3C2.46957 15.5 1.96086 15.2893 1.58579 14.9142C1.21071 14.5391 1 14.0304 1 13.5V1.5Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
        </>
    )
}
export default CreditCardIcon;